import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e4ff74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6" }, " ", -1))
const _hoisted_3 = { class: "col-sm-12 col-md-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label m-0 p-0" }, "ค้นหา:", -1))
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  key: 0,
  class: "card card-empty my-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center align-items-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่พบข้อมูล ")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-auto" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "col d-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }, null, -1))
const _hoisted_16 = { class: "col-auto d-flex align-items-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-edit me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_PaginateComponent = _resolveComponent("PaginateComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "aria-label": "Search",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.keyword) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.filter.keyword,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.display.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.display, (minister, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "card card-minister my-2"
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("img", {
                            class: "photo-image",
                            src: minister.photo,
                            width: "60",
                            height: "70",
                            alt: "preview"
                          }, null, 8, _hoisted_13)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createTextVNode(_toDisplayString(minister.fullName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "btn minister-edit-btn",
                            onClick: ($event: any) => (_ctx.editClick(minister.id))
                          }, [
                            _hoisted_18,
                            _createTextVNode("แก้ไข ")
                          ], 8, _hoisted_17)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
          ], 64))
    ]),
    _createVNode(_component_PaginateComponent, {
      "page-size": _ctx.page.size,
      amount: _ctx.filter.amount,
      total: _ctx.filter.total,
      onCurrentPageChange: _ctx.selectedPage
    }, null, 8, ["page-size", "amount", "total", "onCurrentPageChange"])
  ], 64))
}